import { Injectable } from "@angular/core";
import { CoreService } from "@charlesschwab/sac-ui-core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, concatMap, map, switchMap } from "rxjs/operators";
import { StatusViewService } from "../../shared/services/status-view.service";
import { ValidateWireFlagsService } from "../../shared/services/validate-WireFlags.service";
import { isPalAccountFlow } from "../../shared/utilities/AccountFlow";
import { EAuthorizationActions } from "../actions";
import { EAuthClientService } from "../services/eauth-client.service";
import { EAuthClientsResponse } from "../models/EAuthClients";
import { ReviewPageActions } from "../../create-request/actions";
import { StandingAuthReviewPageActions } from "../../standing-authorizations/actions";

@Injectable()
export class EAuthorizationEffects {
	constructor(
		private actions$: Actions,
		private eAuthClientService: EAuthClientService,
		private coreService: CoreService,
		private validateWireFlagsService: ValidateWireFlagsService,
		private statusViewService: StatusViewService
	) { }

	loadEauthClients$ = createEffect(() =>
		this.actions$.pipe(
			ofType(EAuthorizationActions.loadEAuthClients),
			switchMap((action) => {
				return this.eAuthClientService.getEauthClients(action.accountId, "false", this.isPalAccountInContext()).pipe(
					map((response: EAuthClientsResponse) => {
						return EAuthorizationActions.loadEAuthClientsSuccess({ response: response })
					}),
					catchError(() => of(EAuthorizationActions.loadEAuthClientsFailure({
						errorMsg: "Failed to load eAuth Clients"
					})))
				)
			})
		)
	);

	loadCreateStandingAuthEauthClients$ = createEffect(() =>
		this.actions$.pipe(
			ofType(EAuthorizationActions.loadCreateStandingAuthEAuthClients),
			switchMap((action) => {
				return this.eAuthClientService.getEauthClients(action.accountId, "true", this.isPalAccountInContext()).pipe(
					map((response: EAuthClientsResponse) => {
						return EAuthorizationActions.loadCreateStandingAuthEAuthClientsSuccess({ response: response })
					}),
					catchError(() => of(EAuthorizationActions.loadCreateStandingAuthEAuthClientsFailure({
						errorMsg: "Failed to load eAuth Clients"
					})))
				)
			})
		)
	);

	private isPalAccountInContext(): boolean {
		return isPalAccountFlow(
			this.coreService.currentContext?.contextType,
			this.validateWireFlagsService.enablePalWireCreateTransaction()
		);
	}

	submitEmailAddress$ = createEffect(() =>
		this.actions$.pipe(
			ofType(
				EAuthorizationActions.submitEmailClicked,
				ReviewPageActions.clientAwaitingAllianceUsed,
				StandingAuthReviewPageActions.clientAwaitingAllianceUsed
			),
			concatMap((action) => {
				let request: any = {
					subAccountId: action.accountId,
					customerId: action.customerId,
					emailAddress: action.emailAddress
				};
				return this.statusViewService.updateEmailAddress(request).pipe(
					switchMap(() => {
						return of(EAuthorizationActions.submitEmailSuccess({customerId: action.customerId}));
					}),
					catchError((err) => of(EAuthorizationActions.submitEmailFailure({
						errorMsg: err.error[0]
					}))),
					catchError(() => of(EAuthorizationActions.submitEmailFailureNullResponse()))
				)
			})
		)
	);
}
